import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AppStyles } from "../themes/AppStyles";
import defaultTheme from "../themes";
import Dashboard from "../pages/Dashboard";
import LobConstants from "../constants/LobConstants";

// const Logout = React.lazy(() => import("../pages/Logout"));
const TrackShipment = React.lazy(()=> import("../pages/trackShipment"))

export default function App() {
  const [state, setState] = React.useState({
    theme: defaultTheme.default,
    rightDrawerOpen: false,
    navDrawerOpen:
      window &&
      window.innerWidth &&
      window.innerWidth >= defaultTheme.default.breakpoints.values.md
        ? false
        : true,
  });

  function handleChangeNavDrawer() {
    setState({
      navDrawerOpen: !state.navDrawerOpen,
    });
  }

  const classes = AppStyles();
  const { navDrawerOpen } = state;

  console.log("::: routes")

  return (
    <Switch>
      <Suspense fallback={<div>Loading ... </div>}>
        <Route exact path={`/`} render={() => <Redirect to="/trackShipment" />} />
        <Route exact path={`/trackShipment`} component={TrackShipment} />
      </Suspense>
    </Switch>
  );
}
